import config from './config';
import SiteConfigEnum from "@/enum/siteConfigEnum";

const imgUrlConfig = config.imgUrlConfig

const siteImgConfigList = [
  {
    site_name_info_value: SiteConfigEnum.APARTMENT_SITE,
    site_name_info: "Apartment Management",
    name: "Avatar Solutions",
    urlIcon: require("../../static/images/avatar_logo.png"),
    imgList: [
      {
        url: imgUrlConfig.avatar_logo,
        class: "resize",
        name: "login-logo"
      },
      {
        url: imgUrlConfig.avatar_mini_logo,
        class: "resize-mini",
        name: "mini-logo-sidebar"
      },
      {
        url: imgUrlConfig.avatar_logo,
        class: "avatar-resize-lg",
        name: "lg-logo-sidebar"
      },
      {
        url: imgUrlConfig.avatar_mini_logo,
        class: "resize-project-logo-lg",
        name: "right-logo-navibar"
      },
    ]
  },
  {
    site_name_info_value: SiteConfigEnum.CONASI_SITE,
    site_name_info: "Conasi Home",
    name: "Conasi",
    urlIcon: imgUrlConfig.conasi_mini_logo,
    imgList: [
      {
        url: imgUrlConfig.conasi_logo,
        class: "resize",
        name: "login-logo"
      },
      {
        url: imgUrlConfig.conasi_mini_logo,
        class: "resize-mini",
        name: "mini-logo-sidebar"
      },
      {
        url: imgUrlConfig.conasi_logo,
        class: "resize-lg",
        name: "lg-logo-sidebar"
      },
      {
        url: imgUrlConfig.conasi_mini_logo,
        class: "resize-project-logo-lg",
        name: "right-logo-navibar"
      },
    ]
  },
  {
    site_name_info_value: SiteConfigEnum.TROPICANA_SITE,
    site_name_info: "Tropicana Garden",
    name: "Avatar Solutions",
    urlIcon: require("../../static/images/avatar_logo.png"),
    imgList: [
      {
        url: imgUrlConfig.avatar_logo,
        class: "resize",
        name: "login-logo"
      },
      {
        url: imgUrlConfig.avatar_mini_logo,
        class: "resize-mini",
        name: "mini-logo-sidebar"
      },
      {
        url: imgUrlConfig.avatar_logo,
        class: "avatar-resize-lg",
        name: "lg-logo-sidebar"
      },
      {
        url: imgUrlConfig.avatar_mini_logo,
        class: "resize-project-logo-lg",
        name: "right-logo-navibar"
      },
    ]
  },
  {
    site_name_info_value: SiteConfigEnum.APOLLO_SITE,
    site_name_info: "aHome",
    name: "Apollo Technologies",
    urlIcon: imgUrlConfig.apollo_mini_logo,
    imgList: [
      {
        url: imgUrlConfig.apollo_logo,
        class: "resize",
        name: "login-logo"
      },
      {
        url: imgUrlConfig.apollo_mini_logo,
        class: "resize-mini",
        name: "mini-logo-sidebar"
      },
      {
        url: imgUrlConfig.apollo_logo,
        class: "resize-lg",
        name: "lg-logo-sidebar"
      },
      {
        url: imgUrlConfig.apollo_mini_logo,
        class: "resize-project-logo-lg",
        name: "right-logo-navibar"
      },
    ]
  },
]

export default siteImgConfigList


// WEBPACK FOOTER //
// ./src/lib/siteImgConfig.js